import { Tab, Tabs } from '@material-ui/core'
import BasePage from '../basePage'
import { TabSelect } from './TabSelect'
import { useQueryParam } from 'use-query-params'
import { motion } from "framer-motion";
import { useMenu } from '../../store/global/useMenu';
import { Store, ClipboardList, ClipboardClock, Bike, ListTodo, UtensilsCrossed } from 'lucide-react';
import {useCallback} from "react";

function Configuracoes() {
  const [tab, setTap] = useQueryParam("tab");
  const menuSize = useMenu(st => st.data.size)


  const pageTitle = useCallback(()=>{
    switch(tab){
      case 'dados':
        return <><ClipboardList className='w-7 h-7' />Informações de Loja</>
      case 'horarios':
        return <><ClipboardClock className='w-7 h-7' />Horários de funcionamento</>
      case 'ifood':
        return <><Bike className='w-7 h-7' />Integração Ifood</>
      case '99food':
        return <><UtensilsCrossed className='w-7 h-7' />Integração 99Food</>
      case 'services':
        return <><ListTodo className='w-7 h-7' />Ativação de serviços</>
      default:
        return <><ClipboardList className='w-7 h-7' />Informações de Loja</>
    }
  },[tab])

  return (
    <BasePage pageTitle={pageTitle()}>
      <motion.div
        initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
        transition={{ duration: 0.3 }}
        className='flex flex-col pr-2'
      >
        <Tabs
          value={tab || "dados"}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, value) => setTap(value)}
        >
          <Tab label="DADOS" value="dados" />
          <Tab label="HORÁRIOS DE FUNCIONAMENTO" value="horarios" />
          <Tab label="Integração Ifood" value="ifood" />
          <Tab label="Integração 99Food" value="99food" />
          <Tab label="Ativação de serviços" value="services" />
          {/* <Tab label="EMISSOR DE NOTAS" value="notas" />*/}
          {/* <Tab label="IMPRESSORA" value="printer" />*/}
        </Tabs>
        <TabSelect tab={tab} />
      </motion.div>
    </BasePage>
  )
}

export default Configuracoes
